export default __webpack_public_path__ + "static/media/planeIcon.28f0ed3e.svg";